import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { inject, observer } from 'mobx-react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import './AuthForgot.css';
import { setDigitalData } from '../../Utilities/Utils.js';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: "#3CB6CE",
            main: "#3CB6CE",
            dark: "#3CB6CE",
            contrastText: "#3CB6CE"
        },
        text: {
            primary:"white" ,
            secondary: "white"
        },
        action: {
            active:"white"
        }
    },
    typography : {
        fontFamily: ['Roboto Condensed','Roboto','Helvetica'].join(','),
        fontSize: "20",
    }
});

const styles = {
    resize:{
    },
    labelResize:{
    },
    menuItem:{
        color:'black',
    },
    underline: {
        color: theme.palette.common.white,
        borderBottom: theme.palette.common.white,
        '&:after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:focused::after': {
            borderBottom: `2px solid ${theme.palette.common.white}`,
        },
        '&:before': {
            borderBottom: `1px solid ${theme.palette.common.white}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '2px solid rgb(255, 255, 255) !important',
        },
        '&$disabled:before': {
            borderBottom: `1px dotted ${theme.palette.common.white}`,
        },
    },
    disabled: {},
    focused: {},
    error: {}
}

class DGRAuthForgot extends Component {

    componentDidMount() {
        this.props.DGRBackgroundStore.showBlurAndHeader()
        this.props.DGRStore.values.is_reset_sent = false;
        this.props.DGRStore.errors = null;
        setDigitalData( 'auth forgot', this.props.DGRStore.club_number );
    }

    handleTextChange = (e) => {
        this.props.DGRStore.setValue( e.target.name, e.target.value );
    }
    handleUsernameField = (e) => {
        var pa = e.target.parentElement;
        if ( e.target.checked ) {
            pa.classList.add('radioSelected');
            document.getElementById('forgotFieldPassword').classList.remove('radioSelected');
        }
        this.props.DGRStore.setValue( e.target.name, ( e.target.checked ? 'forgot-username' : 'forgot-password' )  );
    }
    handlePasswordField = (e) => {
        var pa = e.target.parentElement;
        if ( e.target.checked ) {
            pa.classList.add('radioSelected');
            document.getElementById('forgotFieldUsername').classList.remove('radioSelected');
        }
        this.props.DGRStore.setValue( e.target.name, ( e.target.checked ? 'forgot-password' : 'forgot-username' ) );
    }

    handleSubmitUserPass = (e) => {

        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Login',
            action: 'Forgot Form'
        });

        this.props.DGRStore.authForgot().then( response => {
            this.props.DGRStore.setValue( 'is_reset_sent', true );
        })
    }

    render(){
        const { classes } = this.props;

        const { email, forgot_field, is_reset_sent } = this.props.DGRStore.values;

        return(
            <Fade>
            <div className="authLogin">
                <MuiThemeProvider theme={theme}>

                <div className="dgrTitleText">
                    <h2>Reset Login Information</h2>
                </div>

                <div className="dgrTitleSubText">
                    <div className="subText">
                        Enter your email and select the choice to recover your username or reset your password.
                    </div>
                </div>

                <div className="loginItems">  
                    <ValidatorForm
                        className="loginForm"
                        ref="form"
                        autoComplete="off"
                        instantValidate={ false }
                        onSubmit={ this.handleSubmitUserPass }
                        onError={ errors => console.log(errors) }
                    >

                        <div className={ is_reset_sent ? 'hideme' : '' }>

                            <div className="row">
                                <TextValidator
                                    label="Email"
                                    name="email"
                                    id="emailField"
                                    value={ email }
                                    autoComplete="off"
                                    onChange={ this.handleTextChange }
                                    className="inputField"
                                    validators={['required', 'isEmail']}
                                    errorMessages={['This field is required', 'Email is not valid']}
                                    placeholder="eg: name@domain.com"
                                    InputProps={{
                                        classes: {
                                            input: classes.resize,
                                            underline: classes.underline
                                        },
                                    }}
                                    InputLabelProps={{
                                        classes: {
                                            root: classes.labelResize,
                                        },
                                    }}
                                />
                            </div>

                            <div className="row">
                                <label className={ forgot_field === 'forgot-username' ? 'radioLabel radioSelected' : 'radioLabel' }>
                                    <input type="radio" id="forgotFieldUsername" name="forgot_field" value="forgot-username" onChange={ this.handleUsernameField } checked={ forgot_field === 'forgot-username' } />
                                    Forgot Username
                                </label>
                            </div>

                            <div className="row">
                                <label className={ forgot_field === 'forgot-password' ? 'radioLabel radioSelected' : 'radioLabel' }>
                                    <input type="radio" id="forgotFieldPassword" name="forgot_field" value="forgot-password" onChange={ this.handlePasswordField } checked={ forgot_field === 'forgot-password' } />
                                    Forgot Password
                                </label>
                            </div>

                            <div className="continueBtn">
                                <button className="bigButton" type="submit">Continue</button>
                            </div>

                        </div>

                        <div className={ is_reset_sent ? '' : 'hideme' }>
                            <div className="successMessage">
                                <h3>Thank you!</h3>
                                <p>Your request is being processed.</p>
                                <p>If your email is in our system, we will send an email with { forgot_field === 'forgot-password' ? 'instructions to create a new password. Your existing password has not been changed' : 'your username' }.</p>
                            </div>
                        </div>

                        <div className="subLink">
                            <Link to="/auth/login"> 
                                &laquo; Return to login form
                            </Link>
                        </div>

                    </ValidatorForm>

                </div>
                </MuiThemeProvider>
            </div>
            </Fade>
        )
    }
}

DGRAuthForgot = inject('DGRBackgroundStore','DGRStore')( observer( DGRAuthForgot ) )

export default withStyles( styles )( DGRAuthForgot );



// WEBPACK FOOTER //
// ./src/components/DGR/AuthForgot/AuthForgot.js